import type { AxiosError } from "axios";
import { createAsyncAction } from "typesafe-actions";

import type { GetJupyterImagesResponse } from "../../types/responses";

export const actions = {
  getJupyterImages: createAsyncAction(
    "jupyterImages/GET_IMAGES_REQUEST",
    "jupyterImages/GET_IMAGES_SUCCESS",
    "jupyterImages/GET_IMAGES_FAILURE",
  )<void, GetJupyterImagesResponse, AxiosError>(),
};
